import { computed, ref, type Ref, unref } from 'vue'

import { chatModel } from '@/entities/messages'

export const useNavigateToMessage = (pServed: Ref<string> | string) => {
  const {
    findById,
    findRoomMessages,
    isEventInViewport,
    loadViewportAroundEvent,
    getRoomHistoryViewport,
  } = chatModel.useChatMessageStore()

  const isNavigating = ref(false)

  const isAnchoredNavigation = computed(() => {
    return getRoomHistoryViewport(unref(pServed)).mode === 'anchored'
  })

  const ensureMessageLoaded = async (eventId: number): Promise<boolean> => {
    const roomPServed = unref(pServed)
    const normalizedEventId = Number(eventId)

    if (!normalizedEventId) {
      return false
    }

    if (
      findById(normalizedEventId)
      && isEventInViewport(roomPServed, normalizedEventId)
      && findRoomMessages(roomPServed).some((message) => message.eventId === normalizedEventId)
    ) {
      return true
    }

    isNavigating.value = true
    try {
      return await loadViewportAroundEvent(roomPServed, normalizedEventId)
    } finally {
      isNavigating.value = false
    }
  }

  return {
    ensureMessageLoaded,
    isNavigating,
    isAnchoredNavigation,
  }
}
